import {
  ATTENDANCE_ONCE_FETCHING,
  ATTENDANCE_ONCE_FAILED,
  ATTENDANCE_ONCE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ATTENDANCE_ONCE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ATTENDANCE_ONCE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ATTENDANCE_ONCE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
